<template>
    <div :class="['form-group', { 'mb-4': !removeMargin }]">
        <label for="driver_id" v-if="!noLabel">
            <strong>
                Driver
                <span v-if="props.required" class="text-danger">*</span>
            </strong>
        </label>

        <v-select
            v-model="selectedDriver"
            :options="drivers"
            :clearable="!isDisabled"
            placeholder="Select a Driver"
            label="name"
            @search="fetchOptions"
            :disabled="isDisabled"
            @option:selected="updateSelectedDriver"
        />

        <input type="hidden" name="driver_id" id="driver_id" :value="selectedDriver ? selectedDriver.id : ''">

        <div v-if="errors && errors.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, watch } from "vue";
    import axios from 'axios';
    import debounce from 'lodash/debounce';
    import VSelect from 'vue-select';

    const emit = defineEmits(['update-driver']);

    const props = defineProps({
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            default: () => [],
            required: false
        },
        driver: {
            type: Object,
            default: null,
            required: false
        },
        passedDrivers: {
            type: Array,
            default: () => [],
            required: false
        },
        disableWhenPassedDriver: {
            type: Boolean,
            default: true,
            required: false
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        removeMargin: {
            type: Boolean,
            default: false,
            required: false
        },
        noLabel: {
            type: Boolean,
            default: false,
            required: false
        },
    });

    const selectedDriver = ref(props.driver);
    const drivers = ref([]);
    const isDisabled = ref(false);

    const fetchOptions = function (search, loading) {
        loading(true);
        if (search.length === 0) {
            debounceFetchOptions(search, loading);
            loading(false);
        } else if (search.length > 2) {
            debounceFetchOptions(search, loading);
        } else {
            loading(false);
        }
    };

    const debounceFetchOptions = debounce( function(search, loading) {
        loading(true);
        axios.get(generateAllDriversRoute() + '?search=' + search)
            .then(response => {
                drivers.value = [];
                drivers.value = response.data;
                loading(false);
            })
            .catch(error => {
                console.log(error);
            });
    }, 500);

    const updateSelectedDriver = function () {

        if ( selectedDriver.value === null ) {
            drivers.value = [];
            fetchStandardDriverList();
        }

        emit('update-driver', selectedDriver.value);
    };

    const generateAllDriversRoute = function () {
        // todo murder ziggy
        return route('api.movements.drivers.select');
    };

    // todo no one uses agencies sorry
    const addAgencyToDriverName = function () {
        drivers.value.forEach((driver) => {
            if ( driver.agency_id !== null ) {
                driver.name = driver.name + ' (' + driver.agency.name + ')';
            }
        });
    };

    const fetchStandardDriverList = function () {
        axios.get(generateAllDriversRoute())
            .then(response => {
                Object.entries( response.data ).forEach( ([, value]) => {
                    return drivers.value.push( value );
                });
            })
            .catch(error => {
                console.log(error);
            });

        // addAgencyToDriverName();
    };

    onMounted(() => {

        fetchStandardDriverList();

        selectedDriver.value = drivers.value[0];

        // If old is present, select the driver with matching ID
        if (props.old !== null) {
            selectedDriver.value = drivers.value.find(driver => driver.id === props.old) || null;
        }

        // If driver prop is present, fetch and select it
        if (props.driver !== null) {
            axios.get(generateAllDriversRoute() + '?search=' + encodeURIComponent(props.driver.name))
                .then(response => {
                    selectedDriver.value = response.data.find(driver => driver.id === props.driver.id) || null;
                    drivers.value = response.data;
                    if (props.disableWhenPassedDriver) {
                        isDisabled.value = true;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    });

    watch(
        () => props.driver,
        (newDriver) => {
            if ( newDriver !== null ) {
                selectedDriver.value = newDriver;
            }
        }
    );

</script>
